module.exports = __webpack_public_path__ + "img/ss01.f37ef09e.jpg";